import * as jalaliJs from "jalaali-js";

export function convertTimestampToJalaliWithTime(timestamp) {
  const date = new Date(timestamp);

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const g_year = date.getUTCFullYear();
  const g_month = date.getUTCMonth() + 1;
  const g_day = date.getUTCDate();
  const g_hour = date.getHours();
  const g_minute = date.getMinutes();
  const g_second = date.getSeconds();

  const {j_year, j_month, j_day} = gregorianToJalali(g_year, g_month, g_day);

  return `${j_year}/${pad(j_month)}/${pad(j_day)} ${pad(g_hour)}:${pad(g_minute)}:${pad(g_second)}`;
}

function gregorianToJalali(g_year, g_month, g_day) {
  const g_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];

  if ((g_year % 4 === 0 && g_year % 100 !== 0) || g_year % 400 === 0) {
    g_days_in_month[1] = 29;
  }

  let day_of_year = g_day;
  for (let i = 0; i < g_month - 1; i++) {
    day_of_year += g_days_in_month[i];
  }

  let j_year = g_year - 621;
  let j_day_of_year = day_of_year - 79;

  if (j_day_of_year <= 0) {
    j_year--;
    j_day_of_year += 365;
  }

  const is_leap = (j_year % 4 === 3);
  if (is_leap) {
    j_days_in_month[11] = 30;
  }

  let j_month = 1;
  while (j_day_of_year > j_days_in_month[j_month - 1]) {
    j_day_of_year -= j_days_in_month[j_month - 1];
    j_month++;
  }

  const j_day = j_day_of_year;

  return {j_year, j_month, j_day};
}

function pad(number) {
  return number < 10 ? `0${number}` : number;
}

export const convertJalaliToGregorian = (jalaliDate) => {
  if (!jalaliDate || typeof jalaliDate !== "string") {
    return "";
  }

  const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const normalizedDate = jalaliDate.replace(/[۰-۹]/g, (char) => persianNumbers.indexOf(char));

  const parts = normalizedDate.match(/\d+/g);
  if (!parts || parts.length < 3) {
    return "";
  }

  const [yearStr, monthStr, dayStr] = parts;
  const year = parseInt(yearStr, 10);
  const month = parseInt(monthStr, 10);
  const day = parseInt(dayStr, 10);

  if (!year || !month || !day || month < 1 || month > 12 || day < 1 || day > 31) {
    return "";
  }

  try {
    const {gy, gm, gd} = jalaliJs.toGregorian(year, month, day);
    return `${gy}-${String(gm).padStart(2, "0")}-${String(gd).padStart(2, "0")}`;
  } catch (error) {
    console.error("Jalali to Gregorian conversion failed:", error);
    return "";
  }
};

export const dataToEnglishCharacters = (date) => {
  if (!date || typeof date !== "string") {
    return "";
  }

  const persianToEnglishMap = {
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
    // اختیاری: اگر اعداد عربی هم دارید
    "٠": "0",
    "١": "1",
    "٢": "2",
    "٣": "3",
    "٤": "4",
    "٥": "5",
    "٦": "6",
    "٧": "7",
    "٨": "8",
    "٩": "9",
  };

  return date.replace(/[۰-۹٠-٩]/g, (char) => persianToEnglishMap[char] || char);
};
